const initializeBrandMenu = () => {
  document.querySelectorAll(".fs-brand-menu-abc-header-item").forEach((el) => {
    el.addEventListener("click", (e) => {
      const title = e.target.dataset.title;
      const mode = e.target.dataset.mode;
      let container = null;
      if (mode == "drawer") {
        container = document.querySelector(".fs-menu-drawer-store-sp-submenu .fs-sp-submenu");
      } else if (mode == "sp") {
        container = document.querySelector(".fs-submenu.fs-submenu-brands-abc.sp");
      } else {
        container = document.querySelector(".fs-submenu.fs-submenu-brands-abc.pc");
      }
      const target = container.querySelector(`.fs-brand-menu-abc-item[data-title="${title}"`);
      const containerRect = container.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const top = targetRect.top + container.scrollTop - 52 - 72 - containerRect.top - (mode == "drawer" ? 48 : 0);
      container.scrollTo({ top: top, behavior: "smooth" });
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initializeBrandMenu();
});
